import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { accountOptionActions } from './account-option.actions';
import { accountOptionSelectors } from './account-option.reducer';

@Injectable({ providedIn: 'root' })
export class AccountOptionEffects {
   defaultFields: string[] = ['name', 'accountId', 'shortname'];

   defaultOrderingOptions: string[] = ['name:asc'];

   dateTime = new Date();
   staticFilters: string[] = [`activeEndDate >= "${this.dateTime.toISOString()}" or activeEndDate is null`];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      accountOptionSelectors.selectState,
      'accounts',
      this.defaultFields,
      this.defaultOrderingOptions,
      accountOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
